import rp from 'request-promise';

export const authenticate = user => ({
  type: 'AUTHENTICATE',
  user: user,
});

export const deauthenticate = () => ({
  type: 'DEAUTHENTICATE',
});

export const authenticationError = error => ({
  type: 'AUTHENTICATION_ERROR',
  error: error,
});

export const signIn = endpoint => {
  return async dispatch => {
    try {
      const res = await rp({
        method: 'GET',
        uri: endpoint,
        withCredentials: true,
        json: true,
      });
      const user = {
        id: res.id,
        login: res.login,
        name: res.name,
        token: res.token,
        isSeller: res['is_seller'],
      };
      dispatch(authenticate(user));
    } catch (err) {
      console.error(err);
      dispatch(authenticationError(err));
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/auth.js